
export default {

	/** @returns {string | null} */
	authToken: state => state.authToken,

	/** @returns {string | null} */
	refreshToken: state => state.refreshToken,

	/** @returns {string | null} */
	userId: state => state.userId,

	/** @returns {string | null} */
	currentSessionId: state => state.currentSessionId,

	/** @returns {any[]} */
	profiles: state => state.profiles,

	currentProfile: (_, getters) => {
		if (getters.profiles.length === 0) return null

		return getters.profiles.find(entry => entry._id === getters.userId)
	},

	currentProfileStatus: (_, getters) =>
		getters.currentProfile ? getters.currentProfile.status : null,

	isCurrentProfilePending: (_, getters) =>
		getters.currentProfileStatus === 'CONFIRMATION_PENDING',

	/** @returns {boolean} */
	profileLoading: state => state.profileLoading,

	/** @returns {boolean} */
	isAuthenticated: (_, getters) => getters.authToken != null && getters.refreshToken != null,

	/** @returns {string | null} */
	accountRecoverCredentialsId: state => state.accountRecoverCredentialsId,

	/** @returns {string | null} */
	accountRecoverLoginId: state => state.accountRecoverLoginId,

	/** @returns {any[]} */
	credentials: state => state.credentials,

	/** @returns {string | null} */
	// currentCredentialsId: state => state.currentCredentialsId,

	/** @returns {string | null} */
	currentCredentialsId: (_, getters) => {
		const credentials = Array.isArray(getters.credentials)
			? getters.credentials.filter(Boolean)
			: []
		return credentials.find(entry =>
			entry?.metadata?.type === 'EMAIL_AND_PASSWORD')?._id
	},

	/** @returns {any | null} */
	currentCredentials: (_, getters) => {
		const credentials = Array.isArray(getters.credentials)
			? getters.credentials.filter(Boolean)
			: []
		return credentials.find(entry =>
			entry._id === getters.currentCredentialsId)
	},

	/** @returns {boolean} */
	currentCredentials2FAEnabled: (state, getters) => {
		return getters.currentCredentials && getters.currentCredentials.metadata.enable2FA
	},

	authFlowPayload: state => state.authFlowPayload,

	authFlowType: (_, getters) => getters.authFlowPayload.type,

	isOAuthFlow: (_, getters) => getters.authFlowPayload != null,

	authFlowWithProvider: state => state.authFlowWithProvider,

	pendingAccountConfirmation: state => state.pendingAccountConfirmation,

	sessions: state => state.sessions,

	authReady: state => state.authReady,

	refreshDeadline: state => state.refreshDeadline,

	shouldRefreshToken: (_, getters) => {
		return getters.refreshDeadline != null &&
			(Date.now()) > getters.refreshDeadline - 60 * 1e3
	},

	providedUserId: (_, getters) => getters.authFlowPayload?.userAccountId,

	isAccountMismatch: (_, getters) => (
		getters.authFlowPayload != null &&
		typeof getters.authFlowPayload.userAccountId === 'string' &&
		getters.authFlowPayload.userAccountId.length > 0 &&
		getters.authFlowPayload.userAccountId !== getters.userId
	),

}
